<template>
    <div class="member-block">
        <div
            v-infinite-scroll="getMemberDirectoryResult"
            :infinite-scroll-distance="2000"
            class="relative-position">
            <status-overlay class="pt-5 directory_overlay" :action="initialResultsAction"></status-overlay>
            <status-overlay class="pt-5 directory_overlay" :action="lastNameLetterSearchAction"></status-overlay>

            <div v-if="usersList && usersList.length > 0">
                <v-layout
                    row
                    wrap
                    v-for="(user, index) in usersList"
                    :key="user.id"
                    class="member-tile member-tile__image"
                    justify-space-between>
                    <v-flex
                        xs12
                        sm8
                        md9>
                        <v-layout row warp>
                            <v-flex
                                xs3
                                class="flex-grow-overwrite"
                                pr-4>
                                <figure>
                                    <img :key="user.profileImageUrl" :src="profileImage(user.profileImageUrl,user.lastUpdated)"
                                         :data-qe-id="`member-directory_search-result-${index}_profile-image`"
                                         @click="openMemberProfile(user.id)"
                                         :onerror="imageErrorFallback(user.fallbackProfileImageUrl)">
                                </figure>
                                <!--TODO: bring this back when feature is available-->
                                <!-- <span :class="user.isLoggedIn ? 'online-status online' : 'online-status offline' "></span>-->
                            </v-flex>
                            <v-flex class="overflow-hidden" pr-1>
                                <v-layout
                                    column
                                    wrap
                                    class="member-tile__details">
                                    <v-flex>
                                        <v-layout
                                            row
                                            class="member_name flex-grow-overwrite-all"
                                            @click="openMemberProfile(user.id)"
                                            :data-qe-id="`member-directory_search-result-${index}_profile_name_link`">
                                            <v-flex pr-2>
                                                {{memberName(user)}}
                                            </v-flex>
                                            <v-flex
                                                v-if="user.isLifetimeUser"
                                                class="member_name__badge lifetimeBadge"
                                                :data-qe-id="`member-directory_search-result-${index}_lifetime-member`">
                                                {{memberDirectoryPageConstant.label.LIFETIME}}
                                            </v-flex>
                                            <v-flex
                                                v-if="user.isNewUser"
                                                class="member_name__badge newMemberBadge"
                                                :data-qe-id="`member-directory_search-result-${index}_new-member`">
                                                {{memberDirectoryPageConstant.label.NEW}}
                                            </v-flex>
                                            <v-flex
                                                v-if="user.roleForSearch === memberDirectoryPageConstant.label.FORMER_MEMBER"
                                                class="member_name__badge formerMemberBadge"
                                                :data-qe-id="`member-directory_search-result-${index}_former-member`">
                                                {{memberDirectoryPageConstant.label.FORMER_MEMBER}}
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex class="member-tile__details--status member_status">
                                        {{user.roleForSearch}}
                                    </v-flex>
                                    <v-flex class="member-tile__details--positions" v-if="user.roleForSearch !== memberDirectoryPageConstant.label.FORMER_MEMBER
                                         && user.roleForSearch !== memberDirectoryPageConstant.label.MANAGEMENT_ASSOCIATE
                                         && user.roleForSearch !== memberDirectoryPageConstant.label.CHAPTER_ADMIN
                                         && user.roleForSearch !== memberDirectoryPageConstant.label.CHAPTER_MANAGER">
                                        {{truncatePositions(user.currentChampionPositions)}}
                                    </v-flex>
                                    <v-flex class="member-tile__details--positions" v-if="user.roleForSearch ===  memberDirectoryPageConstant.label.MANAGEMENT_ASSOCIATE
                                         && user.roleForSearch !== memberDirectoryPageConstant.label.FORMER_MEMBER">
                                        {{user.position}}
                                    </v-flex>
                                    <v-flex v-if="user.roleForSearch !== memberDirectoryPageConstant.label.FORMER_MEMBER && user.roleForSearch !== memberDirectoryPageConstant.label.CHAPTER_ADMIN
                                        && user.roleForSearch !== memberDirectoryPageConstant.label.CHAPTER_MANAGER" class="member-tile__communities">
                                        <strong v-for="(chapter, n) in communitiesList(user.chapters)" :key="`${chapter.id}_${n}`">
                                            <a class="member-tile__chapter" :data-qe-id="`member-directory_search-result-${index}_chapter-${n}_link`" @click="communityRedirect(memberDirectoryPageConstant.label.CHAPTER_ROUTE, chapter.id, chapter.name)">
                                                {{chapter.name}}
                                                <span v-if="n !== user.chapters.length -1 ">; </span>
                                            </a>
                                        </strong>
                                        <strong v-if="user.networks.length && user.chapters.length"> | </strong>
                                        <strong v-for="(network, n) in communitiesList(user.networks)" :key="`${network.id}_${n}`">
                                            <a class="member-tile__chapter" :data-qe-id="`member-directory_search-result-${index}_network-${n}_link`" @click="communityRedirect(memberDirectoryPageConstant.label.NETWORK_ROUTE, network.id, network.name)">
                                                {{network.name}}
                                                <span v-if="n !== user.networks.length -1 ">; </span>
                                            </a>
                                        </strong>
                                        <strong v-if="user.communityTypeCommunities.length"> | </strong>
                                        <strong v-for="(community, n) in communitiesList(user.communityTypeCommunities)" :key="`${community.id}_${n}`">
                                            <a class="member-tile__chapter" :data-qe-id="`member-directory_search-result-${index}_community-${n}_link`" @click="communityRedirect(memberDirectoryPageConstant.label.COMMUNITY_ROUTE, community.id, community.name)">
                                                {{community.name}}
                                                <span v-if="n !== user.communityTypeCommunities.length -1 ">; </span>
                                            </a>
                                        </strong>
                                    </v-flex>
                                    <v-flex v-else-if="user.roleForSearch !== memberDirectoryPageConstant.label.FORMER_MEMBER" class="member-tile__communities">
                                        <strong v-for="(chapter, n) in chapterNamesSort(user.chapters)" :key="`${chapter.id}_${n}`">
                                            <a class="member-tile__chapter" :data-qe-id="`member-directory_search-result-${index}_chapter-${n}_link`" @click="communityRedirect(memberDirectoryPageConstant.label.CHAPTER_ROUTE, chapter.id, chapter.name)">
                                                {{chapter.name}}
                                                <span v-if="n !== user.chapters.slice(0,4).length -1">| </span>
                                            </a>
                                        </strong>
                                    </v-flex>
                                    <v-flex class="member-tile__details--company" v-if="user.roleForSearch !== memberDirectoryPageConstant.label.FORMER_MEMBER">
                                        <v-flex>{{primaryCompany(user.primaryCompany)}}</v-flex>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3>
                        <v-layout
                                row
                                wrap
                                align-center
                                justify-space-between
                                v-if="canShowConnections(user)"
                                class="member__connections">
                            <v-flex
                                    class="member__connections--contact"
                                    xs5
                                    sm12
                                    md12>
                                <v-layout
                                        row
                                        wrap
                                        align-center
                                        justify-space-between
                                        class="member__connections--icons">
                                    <v-flex xs2 tag="span">
                                        <div slot="append"
                                                     @click="initiateChat(user.id)"
                                                        :data-qe-id="`member-directory_search-result-${index}_chat_link`"
                                                     >
                                                <v-tooltip top>
                                                    <v-icon color="ypo_cta" slot="activator" class="fas fa-comments"></v-icon>
                                                    {{memberDirectoryPageConstant.label.CHAT}}
                                                </v-tooltip>
                                            </div>
                                        </v-flex>
                                        <v-flex xs2 tag="span">
                                            <v-tooltip slot="append" top>
                                                <a slot="activator" v-if="user.primaryPhoneNumber"
                                                   @click="trackContactMember('Phone', user.id)"
                                                    :data-qe-id="`member-directory_search-result-${index}_phone_link`"
                                                    :href="`tel:${PhoneNumberFormat(user.phoneNumberCountryCode, user.primaryPhoneNumber)} ${user.phoneExtension ? memberDirectoryPageConstant.label.PHONE_EXTENSION + user.phoneExtension: ''}`"
                                                    class="member__connections--phone">
                                                    <i slot="activator" class="fas fa-phone"></i>
                                                </a>
                                                <i slot="activator" v-else class="fas fa-phone disabled"></i>
                                                {{memberDirectoryPageConstant.label.PHONE}}
                                            </v-tooltip>
                                        </v-flex>
                                        <v-flex xs2 tag="span">
                                            <v-tooltip slot="append" top>
                                                <a slot="activator" v-if="user.email"
                                                   @click="trackContactMember('Email', user.id)"
                                                    :data-qe-id="`member-directory_search-result-${index}_email_link`"
                                                    :href="`mailto:${user.email}`" class="member__connections--email">
                                                    <i class="fas fa-envelope"></i>
                                                </a>
                                                <i slot="activator" v-else class="fas fa-envelope disabled"></i>
                                                {{memberDirectoryPageConstant.label.EMAIL}}
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex
                                        class="member__connections--connect"
                                        xs2
                                        sm12
                                        text-xs-right
                                        text-sm-left >
                                    <v-flex tag="strong" v-if="user.isConnected">
                                        <v-tooltip slot="append" top>
                                            <v-btn
                                                    slot="activator"
                                                    @click="connectionClicked(user)"
                                                    :data-qe-id="`member-directory_search-result-${index}_connected_link`"
                                                    small
                                                    class="member__btn active uppercase"
                                                    color="ypo_blue--text">
                                                    <span class="hidden-xs fav-icon">
                                                      <i class="fas fa-heart" size="18px" ></i>
                                                    </span>
                                              {{memberProfileConstants.FAVORITE}}
                                        </v-btn>
                                        <span class="uppercase">{{memberProfileConstants.FAVORITE}}</span>
                                    </v-tooltip>
                                </v-flex>
                                <v-flex tag="strong" v-else>
                                    <v-tooltip slot="append" top>
                                        <v-btn
                                                slot="activator"
                                                @click="connectionClicked(user)"
                                                :data-qe-id="`member-directory_search-result-${index}_add-connection_link`"
                                                small
                                                class="member__btn active uppercase">
                                            <span class="hidden-xs">{{memberProfileConstants.ADD_TO_FAVORITE}}</span>
                                            <span class="visible-xs"><i class="fas fa-user-plus"></i></span>
                                        </v-btn>
                                        <span class="uppercase">{{memberProfileConstants.ADD_TO_FAVORITE}}</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-flex>
                            <v-flex xs1 class="visible-xs">
                                <v-btn @click="downloadContactInfo(user.id)" small class="member__btn active uppercase">
                                    <span class=""><i class="fas fa-address-book "></i></span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 v-if="hasErrorDownloadingInMobile(user.id)" class="mobile-download-error">
                                <v-layout>
                                    <v-flex xs11>
                                        {{memberDirectoryPageConstant.label.ERROR_DOWNLOADING_CONTACT}}
                                    </v-flex>
                                    <v-flex xs1>
                                        <i class="fas fa-times" @click="removeErrorDownload(user.id)"></i>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout
                                row
                                wrap
                                align-center
                                justify-center
                                fill-height
                                v-else
                                class="member__connections">
                            <v-flex v-if="user.roleForSearch === memberDirectoryPageConstant.label.FORMER_MEMBER" class="">
                                <v-btn class="primary_btn transparent manage-colict">
                                    {{memberDirectoryPageConstant.label.NO_SOLICIT}}
                                </v-btn>
                            </v-flex>
                            <v-flex v-else>
                                <v-layout align-center>
                                    <v-flex>
                                            <v-btn small depressed :class="[routedFromChamps ? 'primary_btn small manage-contact' : 'primary_btn manage-contact']"
                                        :data-qe-id="`member-directory_search-result-${index}_manage-contact_link`"
                                        @click="routedFromChamps ? openMemberProfile(user.id) : salesforceRedirectUrl(user.id)">
                                    {{ routedFromChamps ? memberDirectoryPageConstant.label.EDIT_PROFILE : memberDirectoryPageConstant.label.MANAGE_CONTACT}}
                                </v-btn>
                                    <br>
                                            <a v-if="routedFromChamps" class="member-tile__advance-settings"
                                                :data-qe-id="`member-directory_search-result-${index}_advance-settings_link`"
                                                @click="salesforceRedirectUrl(user.id)">
                                                {{memberDirectoryPageConstant.label.ADVANCED_SETTINGS}}
                                </a>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout slot="after-container" class="loading-next-status">
                    <status-overlay :action="nextResultsAction" content-height="100px"></status-overlay>
                </v-layout>
            </div>
            <v-layout
                    column
                    v-if="usersList && usersList.length === 0"
                    pl-0
                    pt-3
                    class="no-result">
                <v-flex v-html="noResultsFoundMessage.labelA" pb-1 class="no-result__label1"></v-flex>
                <v-flex class="no-result__label2">
                    <span v-html="noResultsFoundMessage.labelB"></span>
                    <span v-if="noResultsFoundMessage.labelC">{{noResultsFoundMessage.labelC}}</span>
                    <span class="no-result__directory-link"
                            v-if="noResultsFoundMessage.labelC"
                            data-qe-id="view_full_member_directory_link"
                            @click="loadFullDirectory">
                        {{memberDirectoryPageConstant.label.VIEW_FULL_MEMBER_DIRECTORY}}
                    </span>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
    import { storeAction } from '@/store/storeActions.constant';
    import {
        memberDirectoryPageConstant,
        memberConnectionTabs,
        getNoResultStatement,
    } from "../memberDirectoryPage.constants";
    import { imageErrorFallback } from "../../../common/utils/utils";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { routerNames } from "../../appCommon.constants";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { gaDataLayerEvent } from '../../../plugins/analytics';
    import { appConstant } from "../../../app.constant";
    import { memberProfileConstants } from "../../MemberProfile/memberProfile.constants";
    import downloadVcard from "../../../mixins/downloadVcardMixin";
    import orderBy from "lodash/orderBy";
    import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: 'MemberSearchResults',
        components: {
            StatusOverlay,
        },
        mixins: [
            downloadVcard,
        ],
        created() {
            this.routedCommunityId = this.$route.query.navigatedFromId ? this.$route.query.navigatedFromId : '';
            this.routedFromChamps = this.$route.query.navigatedFromChamps ? this.$route.query.navigatedFromChamps : false;
        },
        props: {
            filterLetter: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                memberDirectoryPageConstant,
                routedCommunityId: null,
                routerNames,
                memberProfileConstants,
                mobileAppDownloadErrors: [],
                routedFromChamps: false
            };
        },
        methods: {
            ...mapActions({
                getInitialMemberDirectoryResult: `memberDirectory/${storeAction.getInitialMemberDirectorySearchResults}`,
                getNextMemberDirectoryResult: `memberDirectory/${storeAction.getNextMemberDirectorySearchResults}`,
                setPersonConnect: `memberDirectory/${storeAction.setPersonConnect}`,
                getSalesforceRedirectUrl: `memberDirectory/${storeAction.getSalesforceRedirectUrl}`,
                getChapterAdmin: `memberProfile/${storeAction.getChapterAdmin}`,
                getVCardDetails: `memberProfile/${storeAction.getVCardDetails}`,
                getUserProfile: `memberProfile/${storeAction.getUserProfile}`,
            }),
            ...mapMutations({
                removeConnectedFromConnection: `memberDirectory/${storeMutation.removeConnectedFromConnection}`,
                setMemberDirectorySearchText: `memberDirectory/${storeMutation.setMemberDirectorySearchText}`,
            }),
            getMemberDirectoryResult() {
                if (!this.disableMemberDirectoryInfiniteScroll) {
                    const additionalFiltersFromRoute = this.$route.query.additionalFilters ? JSON.parse(this.$route.query.additionalFilters) : null;
                    if (!this.nextMemberDirectorySearchOffset) {
                        this.getInitialMemberDirectoryResult(additionalFiltersFromRoute);
                    } else {
                        this.getNextMemberDirectoryResult(additionalFiltersFromRoute);
                    }
                }
            },
            imageErrorFallback,
            loadFullDirectory() {
                this.setMemberDirectorySearchText('');
                sessionStorage.removeItem(appConstant.storageKeys.memberDirectoryStoredFilters);
                this.$router.push({
                    path: "/memberDirectoryPage",
                });
            },
            profileImage(imageUrl, lastUpdated) {
                return lastUpdated ? `${imageUrl}?t${new Date(lastUpdated).getTime()}` : `${imageUrl}`;
            },
            memberName(user) {
                let userName = '';
                const firstName = user.preferredName ?
                    user.preferredName :
                    user.firstName;

                userName = `${firstName || ''} ${user.lastName || ''}`;
                return userName;
            },
            openMemberProfile(userId) {
                if (this.currentUserId === userId) {
                    this.$router.push({
                        path: `/memberProfile?memberId=${userId}`,
                        query: { mode: this.routerNames.EDIT, name: this.getQuery() },
                    });
                } else {
                    this.getChapterAdmin(userId)
                        .then(() => {
                            if (this.chapterAdmin) {
                                this.$router.push({
                                    path: `/memberProfile?memberId=${userId}`,
                                    query: { mode: this.routerNames.EDIT, name: this.getQuery() },
                                });
                            } else {
                                this.$router.push({
                                    path: `/memberProfile?memberId=${userId}`,
                                    query: { name: this.getQuery() },
                                });
                            }
                        });
                }
                gaDataLayerEvent(gtmEventName.C_Member_Directory_Profile_Viewed, userId);
            },
            getQuery() {
                if (this.$route.name === this.routerNames.MEMBER_DIRECTORY_PAGE) {
                    return this.memberDirectoryPageConstant.label.MEMBER_DIRECTORY_TITLE;
                }
                const currentRoute = this.$route.query.additionalFilters;
                const connectionOf = memberConnectionTabs()[0];
                const connectedTo = memberConnectionTabs()[1];
                if (currentRoute.includes(connectionOf.filterKey)) {
                    return connectionOf.label;
                } else if (currentRoute.includes(connectedTo.filterKey)) {
                    return connectedTo.label;
                }
            },
            salesforceRedirectUrl(userId) {
                this.getSalesforceRedirectUrl(userId)
                    .then((response) => {
                        window.location = response.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            truncatePositions(data) {
                const dots = "...";
                const truncatedString = data ? data.map(item => item.name).join('; ') : '';
                return truncatedString.length > memberDirectoryPageConstant.label.DIRECTORY_TEXT_LENGTH ?
                    truncatedString.substring(0, memberDirectoryPageConstant.label.DIRECTORY_TEXT_LENGTH) + dots :
                    truncatedString;
            },
            primaryCompany(data) {
                if (data) {
                    const dots = "...";
                    const primaryCompany = data;
                    return primaryCompany.length > memberDirectoryPageConstant.label.DIRECTORY_TEXT_LENGTH ?
                        primaryCompany.substring(0, memberDirectoryPageConstant.label.DIRECTORY_TEXT_LENGTH) + dots :
                        primaryCompany;
                }
            },
            communityRedirect(communityType, communityId, communityName) {
              const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communityId);
              if (hbRedirectCommunity) {
                window.open(hbRedirectCommunity.redirectUrl, '_self');
              } else {
                this.$router.push({
                  path: `/${communityType.toLowerCase()}/${communityId}`,
                  query: { name: communityName },
                });
              }
            },
            communitiesList(communities) {
                const { routedCommunityId } = this;
                let filteredList = [];
                if (communities && communities.length > 0) {
                    if (!routedCommunityId) {
                        return communities;
                    }
                    if (communities.length === 1 || communities[0].id === routedCommunityId) {
                        filteredList = [...communities];
                    } else {
                        const assosiatedCommunity = communities.find(community => community.id === routedCommunityId);
                        if (assosiatedCommunity) {
                            filteredList = communities.filter(community => community.id !== assosiatedCommunity.id);
                            filteredList.unshift(assosiatedCommunity);
                        } else {
                            filteredList = [...communities];
                        }
                    }
                }
                return filteredList;
            },
            connectionClicked(user) {
            const setPersonConnectPromise = this.setPersonConnect({
            user,
            isConnected: !user.isConnected,
            });
            setPersonConnectPromise.then((resp) => {
            user.isConnected = resp.data.isConnected;
            const isMemberConnectionsOrMemberDirectoryPage = this.$route.name === this.routerNames.MEMBER_CONNECTIONS || this.$route.name === this.routerNames.MEMBER_DIRECTORY_PAGE;

            if (!user.isConnected && isMemberConnectionsOrMemberDirectoryPage) {
            const myConnectionFilter = this.$route.query.additionalFilters ? JSON.parse(this.$route.query.additionalFilters) : null;
            const memberDirectoryFilter = this.$route.query.filters ? JSON.parse(this.$route.query.filters) : null;
            const { filterKey } = memberConnectionTabs()[0]; 
            const shouldRemoveConnection = (myConnectionFilter && myConnectionFilter.some(item => item.filterKey === filterKey)) ||
                (memberDirectoryFilter && memberDirectoryFilter.connections && memberDirectoryFilter.connections.some(item => item.filterKey === filterKey));
            if (shouldRemoveConnection) {
                this.removeConnectedFromConnection(user);
            }
            }
            if (user.isConnected) {
            gaDataLayerEvent(gtmEventName.C_Profile_Add_To_Connections, user.id);
            }
            }).catch((error) => {
                console.error("Error occurred while connecting user:", error);
            });
            },

            canShowConnections(data) {
                if (this.routedFromChamps) { return false; }
                return !(data.roleForSearch === memberDirectoryPageConstant.label.FORMER_MEMBER || data.canUserManageContact);
            },
            PhoneNumberFormat(countryCode, phoneNumber) {
                if (phoneNumber) {
                    if (countryCode && phoneNumber.length >= memberDirectoryPageConstant.label.PHONE_NUMBER_LENGTH) {
                        return `+${countryCode} ${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, phoneNumber.length)}`;
                    } else if (phoneNumber.length >= memberDirectoryPageConstant.label.PHONE_NUMBER_LENGTH) {
                        return `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, phoneNumber.length)}`;
                    }
                }
            },
            chapterNamesSort(chapters) {
                const chapterManagerChapters = orderBy(chapters, 'name', 'asc').slice(0, 4);
                return this.communitiesList(chapterManagerChapters);
            },
            initiateChat(userId) {
                this.$router.push({
                  path: `/${routerNames.MESSENGER}`,
                  query: { to: userId },
                });
                this.trackContactMember('Chat', userId);
            },
            trackContactMember(contactType, userId) {
                gaDataLayerEvent(gtmEventName.C_Profile_Contact_Profile_Initiated, `${contactType} - ${userId}`);
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                memberDirectorySearchResults: `memberDirectory/${storeGetters.memberDirectorySearchResults}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
                memberDirectorySearchText: `memberDirectory/${storeGetters.memberDirectorySearchText}`,
                disableMemberDirectoryInfiniteScroll: `memberDirectory/${storeGetters.disableMemberDirectoryInfiniteScroll}`,
                nextMemberDirectorySearchOffset: `memberDirectory/${storeGetters.nextMemberDirectorySearchOffset}`,
                chapterAdmin: `memberProfile/${storeGetters.chapterAdmin}`,
                vCardDetails: `memberProfile/${storeGetters.vCardDetails}`,
                userProfile: `memberProfile/${storeGetters.userProfile}`,
                isAndroidAppBrowser: `${[storeGetters.isAndroidAppBrowser]}`,
                isIosAppBrowser: `${[storeGetters.isIosAppBrowser]}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
            }),
            usersList() {
                return this.memberDirectorySearchResults && this.memberDirectorySearchResults.searchResults
                    ? this.memberDirectorySearchResults.searchResults :
                    [];
            },
            initialResultsAction() {
                return this.actions[storeAction.getInitialMemberDirectorySearchResults];
            },
            lastNameLetterSearchAction() {
                return this.actions[storeAction.getMemberDirectorySearchResultByLastName];
            },
            nextResultsAction() {
                return this.actions[storeAction.getNextMemberDirectorySearchResults];
            },
            noResultsFoundMessage() {
                const pageType = this.$route.query.additionalFilters ? JSON.parse(this.$route.query.additionalFilters) : null;
                return getNoResultStatement(this.memberDirectorySearchText, this.selectedFilters, this.$route.name, pageType);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .disabled {
        color: $ypo-dark-gray !important;
        opacity: .5;
    }

    .mobile-download-error {
        font-size: 12px;
        color: $ypo-error-red;
    }

    .member__btn {
        padding: 0;
        min-width: auto;
        background: transparent !important;
        box-shadow: none !important;
        height: auto;
        font-size: 12px;
        margin: 0;
        font-weight: bold;
        font-family: sans-serif !important;

        &.active {
            color: $ypo-cta;

            i {
                color: $ypo-cta;
                margin-top: 0;
                font-size: 18px;
                margin-right: 0;
                padding-right: 0;
            }
        }

        &:hover {
            &:before {
                background-color: transparent;
            }

            &:active {
                background-color: transparent;
            }
        }

        &:focus {
            background-color: transparent;
        }
        .fav-icon {
            display: inline-flex;
            vertical-align: middle;
            margin-right: 5px;
        }
    }

    .member_name {
        color: $ypo-cta;
        font-size: 18px;
        font-weight: bold;
        font-family: 'Noto Sans', sans-serif;

        & a {
            color: $ypo-cta;
        }

        &__badge {
            color: $white;
            letter-spacing: .59px;
            padding: 1px 7px;
            font-weight: 500;
            max-height: 20px;
            margin-top: 2px;
            text-transform: uppercase;
            font-size: 12px;

            @include breakpoint(sm) {
                margin-top: 0;
            }

            @include breakpoint(xs) {
                font-size: 10px;
                padding: 1px 4px;
                height: 16px;
                margin-top: 2px;
            }
        }

        .lifetimeBadge {
            background: $ypo_gold;
        }

        .newMemberBadge {
            background: $ypo_blue;
        }

        .formerMemberBadge {
            background: $ypo-gray;
        }
    }

    .member_status {
        font-size: 14px;
        height: 19px;
        line-height: normal;
        color: $ypo-blue;
        text-transform: uppercase;
    }

    .member-block {
        font-family: 'Noto Sans', sans-serif;
        font-size: 16px;
        margin: 0 auto;
        color: $ypo-gray-text;
        min-height: 160px;
        position: relative;

    }

    .member-tile {
        padding: 20px 5px 5px 15px;
        transition: 0.3s all ease;
        min-height: 176px;
        border-bottom: 1px solid rgba($ypo-gray, 0.5);
        cursor: pointer;

        &:hover {
            background: rgba($ypo-cta, 0.09);
        }

        @include breakpoint(md) {
            border: 0;
        }

        figure {
            height: 114px;
            border-radius: 50%;
            width: 114px;
            overflow: hidden;
            text-align: center;
            border: 4px solid $ypo-open-blue-gray;

            img {
                max-width: 100%;
                width: 100%;
            }
        }

        .online-status {
            border: 2px solid $ypo-open-blue-gray;
            width: 18px;
            height: 18px;
            position: absolute;
            right: 15px;
            bottom: 6px;
            z-index: 1;
            border-radius: 50%;

            &.online {
                background: radial-gradient(circle, $ypo-light-green 10%, $ypo-medium-green 100%);
            }

            &.busy {
                background: radial-gradient(circle, $ypo-error-red 0%, $ypo-red 100%);
            }

            &.offline {
                display: none;
                background: radial-gradient(circle, $ypo-prospect-list-border 0%, $ypo-duskblue 100%);
            }
        }

        &__details {
            width: 100%;

            &--info {
                line-height: 8px;
            }

            &--positions {
                line-height: 24px;
                font-size: 14px;
                color: $black;
                margin-top: 15px;
            }

            &--divider {
                min-height: 16px;
            }

            &--company {
                font-size: 14px;
                color: $black;
                margin-top: 10px;

                @include breakpoint(xs) {
                    padding-bottom: 5px;
                }
            }
        }

        &__chapter {
            text-decoration: none;
            font-weight: bold;
            color: $ypo-cta;

            &:hover {
                text-decoration: underline;
            }
        }

        &__communities {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            line-height: 24px;
            max-width: 90% !important;
            font-family: 'Noto Sans', sans-serif;

            @include breakpoint(sm) {
                max-width: 85% !important;
            }

            @include breakpoint(xs) {
                max-width: 80% !important;
            }
        }
        &__advance-settings {
            font-size: 16px;
            font-weight: 600;
            color: $ypo-cta;
            padding: 2px;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .member__connections {
        padding: 0 20px 30px 20px;
        line-height: 30px;
        border-left: 1px solid rgba($ypo-gray, 0.5);

        &--email {
            color: $ypo_cta;
        }

        &--phone {
            color: $ypo_cta;
        }

        &--contact {
            color: $ypo-cta;
            min-height: 55px;

            h3 {
                margin-bottom: 24px;
            }

            i {
                font-size: 24px;
            }

            span {
                position: relative;
                line-height: 40px;
            }
        }

        @include breakpoint(xs) {
            padding-bottom: 7px;
            border: none;

            .manage-contact {
                padding: 2px 10px;
                margin: 0 0 0 43px;
            }

            .manage-colict {
                padding: 2px 10px;
                margin: 0 0 0 35px;
            }
        }
    }

    .loading-next-status {
        position: relative;
        min-height: 100px;
    }

    .no-result {
        font-family: 'Noto Sans', sans-serif;

        &__label1 {
            font-size: 18px;
            font-weight: 600;
        }

        &__label2 {
            font-size: 15px;
        }

        &__directory-link {
            color: $ypo-cta;
            font-weight: 600;
            cursor: pointer;
        }
    }

    @media (max-width: 1199px) {
        .member-tile {
            border: 1px solid rgba($ypo-gray, 0.2);
            border-radius: 5px;
            box-shadow: 0 1px 3px 0 rgba($black, 0.18);
            margin-bottom: 15px;

            &__details {
                &--positions {
                    margin-top: 10px;
                }

                &--company {
                    margin-top: 0;
                }
            }
        }
    }

    @media (max-width: 1023px) {
        .member-tile {
            &__image {
                min-height: 100px;

                figure {
                    width: 70px;
                    height: 70px;
                }

                .online-status {
                    right: 0px;
                }
            }

            &__details {

                .member_name {
                    font-size: 16px;
                }

                &--positions {
                    font-size: 12px;
                }

                &--company {
                    font-size: 12px;
                }

            }

            .member__connections {
                bottom: -5px;
                left: 0;
                width: 100%;

                &--contact {
                    min-height: inherit;

                    span {
                        line-height: normal;
                    }

                    i {
                        font-size: 18px;
                    }
                }

                &--follow {
                    text-align: left !important;
                }

                &--connect {
                    margin-left: 0;
                    font-size: 12px;
                    font-weight: 600;
                    letter-spacing: 0.07px;
                }
            }

            &__chapter {
                font-size: 12px;
            }

            &:hover {
                background: transparent;
            }
        }
    }

    @media (max-width: 767px) {
        .member-block {
            padding: 10px;
        }

        .member-tile {
            min-height: 150px;
            padding-bottom: 0;

            &__image {
                margin-bottom: 15px;
                min-height: inherit;
                box-shadow: none;
                padding: 10px 10px 0 10px;

                figure {
                    width: 60px;
                    height: 60px;
                    border-width: 2px;
                }

                &__info {
                    left: 5px;
                }

                .online-status {
                    bottom: 0px;
                }
            }

            &__details {
                .member_name {
                    font-size: 14px;
                }

                &--positions {
                    line-height: normal;
                    margin-top: 10px;

                    .flex {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }

                }

                .member_status {
                    font-size: 12px;
                }

                &--company {
                    margin-top: 0;

                    .flex {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                }
            }

            .member__connections {
                position: relative;
                bottom: 0px;
                border-top: 1px solid $ypo-medium-gray;
                flex: auto;
                width: auto;
                max-width: initial;
                margin: 5px -10px 0 -10px;
                padding: 5px 10px;

                &--follow {
                    text-align: center !important
                }

                .v-btn__content {
                    font-size: 10px !important;
                }
            }

            &__communities {
                line-height: normal;
            }

        }
    }
</style>
